<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/foreword"><span class="item-title-text">Foreword</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/introduction"><span class="item-title-text">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter001"><span class="item-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter002"><span class="item-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter003"><span class="item-title-text">Chapter 3</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter004"><span class="item-title-text">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter005"><span class="item-title-text">Chapter 5</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter006"><span class="item-title-text">Chapter 6</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter007"><span class="item-title-text">Chapter 7</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter008"><span class="item-title-text">Chapter 8</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="item-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/beforeyougo"><span class="item-title-text">Before You Go…</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/alsobyrevdrteresacitro"><span class="item-title-text">Also by Rev. Dr. Teresa Citro</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/abouttheauthors"><span class="item-title-text">About The Authors</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?aa68a252